require('dom-slider');

const { slideToggle, slideUp } = window.domSlider;
const columns = document.querySelectorAll('.block-text-overflow-column');
const maxToShow = 16;

const nextAll = (element) => {
	const siblings = [];
	let sibling = element.nextElementSibling;
	while (sibling) {
		if (sibling.nodeType === 1) {
			siblings.push(sibling);
		}
		sibling = sibling.nextElementSibling;
	}
	return siblings;
};

const overflowColumns = () => {
	const width = getBrowserWidth();

	if (columns.length) {
		columns.forEach((overflowColumn) => {
			const list = overflowColumn.querySelector(
				'.block-text-overflow-column__container > .wp-block-list:first-of-type'
			);
			const listItems = overflowColumn.querySelectorAll(
				'.block-text-overflow-column__container > .wp-block-list:first-of-type > li'
			);
			const listCount = listItems.length;
			const numItemsToHide = listCount - maxToShow;

			const ul = overflowColumn.querySelector('.wp-block-list--hidden');
			if (listCount > maxToShow) {
				const item18 = list.querySelector(
					'.wp-block-list-item:nth-child(16)'
				);

				const hiddenContent = nextAll(item18);
				if (hiddenContent.length) {
					hiddenContent.forEach((content) => {
						const clonedItem = content.cloneNode(true);
						ul.append(clonedItem);
					});

					slideUp({
						element: ul,
						slideSpeed: 0,
					});
				}
				if (width <= 768) {
					const itemsToHide = list.querySelectorAll(
						`li:nth-last-child(-n+${numItemsToHide})`
					);

					if (itemsToHide.length) {
						overflowColumn.querySelector(
							'.block-text-overflow-column__button'
						).style.display = 'block';
						itemsToHide.forEach((item) => {
							item.classList.add('hide');
						});
					}

					overflowColumn.querySelector(
						'.block-text-overflow-column__button'
					).style.display = 'block';
				}

				const toggleButton = overflowColumn.querySelector(
					'.block-text-overflow-column__button'
				);

				toggleButton.addEventListener('click', toggleContent);
			} else if (getBrowserWidth <= 768) {
				list.style.columns = '2 auto';
			}
		});
	}
};

const resized = () => {
	const width = getBrowserWidth();

	if (width >= 768) {
		if (columns.length) {
			columns.forEach((overflowColumn) => {
				const list = overflowColumn.querySelector(
					'.block-text-overflow-column__container > .wp-block-list:first-of-type'
				);

				const listItems = overflowColumn.querySelectorAll(
					'.block-text-overflow-column__container > .wp-block-list:first-of-type > li'
				);
				const listCount = listItems.length;
				const numItemsToHide = listCount - maxToShow;

				if (listCount > maxToShow) {
					const itemsToShow = list.querySelectorAll(
						`li:nth-last-child(-n+${numItemsToHide})`
					);

					if (itemsToShow.length) {
						itemsToShow.forEach((item) => {
							item.classList.remove('hide');
						});
					}
				}
			});
		}
	} else {
		columns.forEach((overflowColumn) => {
			const list = overflowColumn.querySelector(
				'.block-text-overflow-column__container > .wp-block-list:first-of-type'
			);

			const listItems = overflowColumn.querySelectorAll(
				'.block-text-overflow-column__container > .wp-block-list:first-of-type > li'
			);
			const listCount = listItems.length;

			const numItemsToHide = listCount - maxToShow;
			if (listCount > maxToShow) {
				const itemsToHide = list.querySelectorAll(
					`li:nth-last-child(-n+${numItemsToHide})`
				);

				if (itemsToHide.length) {
					itemsToHide.forEach((item) => {
						item.classList.add('hide');
					});
				}
				overflowColumn.querySelector(
					'.block-text-overflow-column__button'
				).style.display = 'block';
			} else {
				overflowColumn.querySelector(
					'.block-text-overflow-column__button'
				).style.display = 'none';
			}
		});
	}
};

const toggleContent = (e) => {
	e.preventDefault();

	e.currentTarget.classList.toggle('active');

	if (e.currentTarget.classList.contains('active')) {
		e.currentTarget.innerHTML =
			e.currentTarget.getAttribute('data-text-open');
	} else {
		e.currentTarget.innerHTML =
			e.currentTarget.getAttribute('data-text-closed');
	}

	const hiddenContent = e.currentTarget.nextElementSibling;

	slideToggle({
		element: hiddenContent,
		slideSpeed: 400,
		easing: 'ease-in-out',
	});
};

const getBrowserWidth = () => {
	return window.innerWidth;
};
// GLOBAL APP CONTROLLER
const controller = {
	init() {
		overflowColumns();
	},
	loaded() {},
	resized() {
		resized();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
